exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-episode-tsx": () => import("./../../../src/templates/episode.tsx" /* webpackChunkName: "component---src-templates-episode-tsx" */)
}

